import * as React                     from 'react';
import icons                          from '../../icons';
import env                            from '../../env';
import { ConversationContainerProps } from './ConversationTypes';

// components
import Header                         from '../../components/Header';
import DropdownMenu                   from '../../components/DropdownMenu';
import MenuItem                       from '../../components/MenuItem';
import MessagesFeed                   from '../MessagesFeed';
import ContactPanel                   from '../Contact';

const Conversation: React.StatelessComponent<ConversationContainerProps> = ({ conversationId, recipient, onDesktop, history, contactPanelVisible, toggleContactPanel, isOnCallList, loadMessages, translate, session }) => conversationId && recipient ? (
    <div className="messageFeed__view flexbox__column">
        <div className="flexbox__row">
            <div className="flexbox__column">
                <Header
                    session={session}
                    recipient={recipient}
                    titleAction={toggleContactPanel}
                    rightContent="renderChildren"
                    leftLabel={onDesktop ? null : icons.leftArrow}
                    leftAction={onDesktop ? null : () => history.push(`/`)}
                >
                    <DropdownMenu
                        className="settingsMenu header__button"
                        align="left"
                        closeOnOutsideClick={true}
                        toggleLabel={translate('actions')}
                    >
                        <MenuItem
                            onClickAction={() => history.push(`/log/${conversationId}`)}
                            label={translate('log_an_activity')}
                        />
                        <MenuItem
                            onClickAction={() => (window.location.href = `${env.WEBAPP_HOST}accounts`)}
                            label={translate('statflo_crm')}
                            target="_blank"
                        />
                    </DropdownMenu>
                </Header>
                <MessagesFeed
                    contactId={recipient.contact_id}
                    loadMessages={loadMessages}
                    recipient={recipient}
                    conversationId={conversationId}
                    onDesktop={onDesktop}
                />
            </div>
            <ContactPanel
                banId={recipient.ban_id}
                contactId={recipient.contact_id}
                contactPanelVisible={contactPanelVisible}
                toggleContactPanel={toggleContactPanel}
                onDesktop={onDesktop}
                conversationId={conversationId}
                history={history}
            />
        </div>
    </div>
) : null;

export default Conversation;



// WEBPACK FOOTER //
// ./src/sections/Conversation/ConversationComponent.tsx